// client/src/lib/api.ts
import { TeamMember, ContentBlock } from "./types";

// CRA requires direct access so the value is inlined at build time.
const BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

// Optional: small debug log you can remove after confirming
if (!BASE) {
  // eslint-disable-next-line no-console
  console.warn("API BASE URL is empty. Set REACT_APP_API_BASE_URL in client/.env.local");
} else {
  // eslint-disable-next-line no-console
  console.log("API base:", BASE);
}

function toUrl(path: string) {
  return `${BASE}${path.startsWith("/") ? path : `/${path}`}`;
}

export async function apiGet<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(toUrl(path), {
    ...init,
    headers: { Accept: "application/json", ...(init?.headers || {}) },
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json() as Promise<T>;
}

export async function apiPost<T>(path: string, body: unknown, init?: RequestInit) {
  const res = await fetch(toUrl(path), {
    method: "POST",
    body: JSON.stringify(body),
    headers: { "Content-Type": "application/json", Accept: "application/json", ...(init?.headers || {}) },
    ...init,
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json() as Promise<T>;
}

// keep your mock helpers
export async function getTeamMember(slug: string): Promise<TeamMember> {
  return { id: "1", slug, name: "Alex Harmaty", role: "Backend Engineer", bio: "This is a placeholder bio.", photoUrl: undefined };
}
export async function getContent(slug: string): Promise<ContentBlock<string>> {
  return { slug, kind: "markdown", data: "Placeholder content", updatedAt: new Date().toISOString() };
}
